import React from "react"

const FuelDealIcon = () => (
  <svg
    width="57"
    height="49"
    viewBox="0 0 57 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4.5" width="49" height="49" rx="24.5" fill="#FED7AA" />
    <path
      d="M16.8896 43.4416L9.99597 44.6571C7.8204 45.0408 5.74576 43.5881 5.36215 41.4125L4.2158 34.9112C5.81108 33.7054 6.69071 31.6709 6.31962 29.5663C5.9485 27.4615 4.42611 25.8496 2.51442 25.2622L1.19459 17.7771C0.81098 15.6015 2.26365 13.5269 4.43923 13.1433L11.3329 11.9278L16.8896 43.4416Z"
      fill="#FF982C"
    />
    <path
      d="M11.332 11.9277L46.6835 5.69431C48.8591 5.3107 50.9337 6.76337 51.3173 8.93895L55.4849 32.5743C55.8685 34.7499 54.4158 36.8245 52.2403 37.2082L16.8888 43.4416L11.332 11.9277Z"
      fill="#D97706"
    />
    <mask
      id="mask0_32_2772"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="22"
      y="12"
      width="24"
      height="24"
    >
      <rect
        x="22.1719"
        y="16.1094"
        width="20"
        height="20"
        transform="rotate(-10 22.1719 16.1094)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_32_2772)">
      <path
        d="M29.3551 32.6124C29.1227 32.6533 28.9061 32.6035 28.7053 32.4629C28.5037 32.3218 28.3824 32.135 28.3415 31.9026L26.1926 19.7156C26.1082 19.237 26.2041 18.8004 26.4805 18.4057C26.7563 18.0118 27.1335 17.7727 27.6121 17.6883L32.4337 16.8381C32.9123 16.7537 33.3489 16.8494 33.7434 17.125C34.1374 17.4015 34.3766 17.779 34.461 18.2577L35.4668 23.9617L36.616 23.759C36.9719 23.6963 37.3012 23.7651 37.6039 23.9656C37.9073 24.166 38.0903 24.4437 38.153 24.7989L38.8622 28.8209C38.9007 29.0395 39.0051 29.2113 39.1754 29.3363C39.3457 29.4613 39.5402 29.5045 39.7588 29.466C39.9774 29.4274 40.1454 29.3203 40.2626 29.1446C40.3799 28.9689 40.4193 28.7717 40.3807 28.5531L39.346 22.6846C39.2185 22.764 39.0918 22.8252 38.9661 22.8684C38.8397 22.9117 38.7013 22.9466 38.551 22.9731C37.9758 23.0745 37.4473 22.9561 36.9652 22.618C36.4819 22.2802 36.1896 21.824 36.0883 21.2495C36.011 20.8116 36.0684 20.396 36.2604 20.0027C36.4517 19.6095 36.7327 19.3027 37.1034 19.0823L35.6553 18.0684C35.5101 17.9667 35.4219 17.8273 35.3906 17.65C35.3592 17.4721 35.3944 17.3105 35.496 17.1653C35.5972 17.0209 35.7367 16.933 35.9146 16.9016C36.0925 16.8703 36.2537 16.9051 36.3981 17.0063L39.3806 19.0403C39.6217 19.2096 39.8212 19.4212 39.979 19.675C40.1362 19.9296 40.2414 20.2072 40.2944 20.5079L41.6728 28.3253C41.7741 28.8998 41.6614 29.4202 41.3348 29.8867C41.0082 30.3532 40.5576 30.6371 39.9831 30.7384C39.4087 30.8396 38.8882 30.727 38.4217 30.4004C37.9553 30.0737 37.6714 29.6232 37.5701 29.0487L36.8609 25.0268L35.691 25.233L36.6099 30.4446C36.6509 30.6771 36.6011 30.894 36.4606 31.0955C36.3194 31.2964 36.1325 31.4173 35.9001 31.4583L29.3551 32.6124ZM28.6179 23.3923L33.4395 22.5421L32.7376 18.5615L27.916 19.4117L28.6179 23.3923ZM38.3428 21.6775C38.5752 21.6366 38.7563 21.5234 38.8861 21.338C39.0159 21.1527 39.0603 20.9438 39.0193 20.7114C38.9784 20.479 38.8652 20.2982 38.68 20.1691C38.4947 20.0393 38.2858 19.9949 38.0534 20.0359C37.8209 20.0768 37.6402 20.1899 37.511 20.3752C37.3811 20.5599 37.3367 20.7684 37.3777 21.0009C37.4186 21.2333 37.5318 21.4144 37.7172 21.5442C37.9019 21.6741 38.1104 21.7185 38.3428 21.6775ZM29.9129 30.737L34.7345 29.8868L33.7434 24.2655L28.9217 25.1157L29.9129 30.737Z"
        fill="white"
      />
    </g>
  </svg>
)

export default FuelDealIcon
